import axios from 'axios';

let headerz = null

if(window.sessionStorage.getItem('ses_mogi')) {
    headerz = {'Authorization' : `Bearer ${window.sessionStorage.getItem('ses_mogi')}`}
}

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL+"/stok/api/v2/",
  responseType: "json",
  headers: headerz
});